import React from 'react'

export const ProgressHeader = ({progressTab, setProgressTab, progressList}) => {
  
    return (
      
      <div style={{display:"flex", cursor:"pointer", minHeight:"60px", backgroundColor:"white", justifyContent:"center", alignItems:"center", marginTop:"15px", marginBottom:"15px"}}>
          {progressList?.map?.((item, index)=>{
               const activeBackground = progressTab?.description == item?.description ? {backgroundColor:"#CCC"} : {}
              return(
              <div key={index} onClick={()=>{setProgressTab({...item, index})}} style={{display:"flex", justifyContent:"center", alignItems:"center", minHeight:"60px", height:"100%", ...activeBackground}}>
                  <h5 style={{padding:"10px"}}>{`${index+1}.${item?.description}`}</h5>
               </div>
              )
          })}
  
      </div>
    )
  }
